import React from "react";

import RatingStar from "../../assets/images/rating.png";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { MentorsData } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";

import styles from "./Mentors.module.css";

export default function Mentors() {
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_FEATURE_MENTORS
  );
  const apiData = response?.featuredMentors ?? MentorsData;
  const navigate = useNavigate();
  return (
    <section className={styles.mentors}>
      <div className={styles.container}>
        <div className={styles.topContainer}>
          <div className={styles.heading}>
            <h3>
              Featured <span>Mentors</span>
            </h3>
            <h5>Connect with leading researchers and their latest work</h5>
          </div>
          {/* <div className={styles.filter}>
            <CustomSelectBox options={SelectOptions} />
          </div> */}
        </div>
        <div className={styles.cards}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData.slice(0, 3).map((t) => (
              <article className={styles.card} key={t.id}>
                <div className={styles.userDetails}>
                  <figure>
                    <img src={t.mentor.photograph} alt={t.title} />
                  </figure>
                  <div className={styles.content}>
                    <h6>{t.mentor.full_name}</h6>
                    <p title={`${t.mentor.current_designation} |  ${t.mentor.departmentFacultyName} | ${t.mentor.institution_name},  ${t.mentor.city}`}>
                      {t.mentor.current_designation} |  {t.mentor.departmentFacultyName} | {t.mentor.institution_name},  {t.mentor.city}
                    </p>
                  </div>
                </div>
                    
                <div className={styles.details}>
                  {t.mentor.profileSummary?.length > 88
                    ? `${t.mentor.profileSummary.substring(0, 88)}...`
                    : t.mentor.profileSummary}
                </div>
                <div className={styles.tagOuter}>
                  <button
                    onClick={() => navigate(`/mentors/${t.mentor.user_id}`)}
                  >
                    View Profile
                  </button>
                  {/* <button
                    className={styles.active}
                    onClick={() => navigate(`/mentors/${t.mentor.user_id}`)}
                  >
                    Request Session
                  </button> */}
                </div>
              </article>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
